import PubSub from 'pubsub-js';

export const pubsub = PubSub;

export const CREATED_TODO_EVENT = 'created_todo_event';
export const DELETE_TODO_EVENT = 'delete_todo_event';
export const UPDATE_TODO_EVENT = 'update_todo_event';
export const UPDATE_TODO_BONUS_EVENT = 'update_todo_bonus_event';
export const BATCH_CREATED_TODO_EVENT = 'batch_created_todo_event';

export const CLOSE_TAG_VIEW_EVENT = 'close_tag_view_event';
export const CHANGE_SOLUTION_STATUS = 'change_solution_status';
